import { time, bridge, store } from "@dinahmoe/dmafjs-core";
import { WebAudioSound } from "./sound.js";

class Sampler extends WebAudioSound {
  namespace = "webaudio:sampler";

  init(node) {
    super.init(node);

    if (node.props.samplemap) {
      node.map = store.get(`assets.data.${node.props.samplemap}`);
    }

    if (node.map && node.map.length > 0) {
      let previous = -1;
      for (let i = 0; i < node.map.length; i++) {
        if (node.map[i].low > previous) {
          previous = node.map[i].low;
        } else {
          console.error(
            "this samplemap is unsorted",
            node.props.samplemap,
            node.map
          );
          break;
        }
      }
    } else {
      console.warn("Missing samplemap or samples", node.props.samplemap);
    }
  }

  execute(node, event) {
    if (!event?.data?.type) {
      console.warn("Sampler received event without data.type");
      return;
    }
    switch (event.data.type) {
      case "noteOn":
        this.playNote(node, event);
        break;
      default:
        console.error("Unhandled event type", event.data.type);
        break;
    }
  }

  playNote(node, event) {
    if (event.time < time.current) {
      console.error("event.time is historical:", event.time);
      return;
    }

    const midiNote = event.data.midiNote + node.props.transpose;
    let item;
    for (let i = 0; i < node.map.length; i++) {
      if (midiNote <= node.map[i].high && midiNote >= node.map[i].low) {
        item = i;
        break;
      }
    }

    let sampleData;

    if (item >= 0 && item < this.map.length) {
      sampleData = node.map[item];
    } else {
      console.error("midi note is outsde samplemap range: ", midiNote);
      return;
    }

    const diff = midiNote - sampleData.root;
    const playbackRate = Math.pow(1.059463094359295, diff);

    bridge.update({
      uid: "webaudio/" + node.uid,
      key: "playNote",
      value: {
        time: event.time,
        assetId: sampleData.assetUid,
        playbackRate: playbackRate,
        midiNote: midiNote,
        velocity: event.data.velocity,
        duration: event.data.durationInMs,
      },
      sender: "core",
    });
  }
}

const sampler = new Sampler();
export { sampler, Sampler };
